// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bW","content":"bX","header":"bY","message":"bZ","iframeWrapper":"b0"};